import {
  ESTRATEGIA_RETRY_PADRAO,
  FalhaHttp,
  type ClienteHttp,
  type RespostaHttp,
} from '@next/infraestrutura/http'

import type { OpcaoLocalDeTrabalho } from '../catalogo-local-de-trabalho.tipos'

const ENDPOINT = '/company'
const CAMPOS = [
  'id', 'name', 'code', 'active', 'visivel', 'empregadores',
  'priority', 'ddd', 'region', 'total_of_employees', 'has_on_call',
] as const
const CAMPOS_RESPOSTA = [
  'id', 'name', 'code', 'active', 'visivel', 'empregadores',
  'priority', 'ddd', 'region', 'totalOfEmployees', 'hasOnCall',
] as const

const ehRegistro = (valor: unknown): valor is Record<string, unknown> => (
  typeof valor === 'object' && valor !== null && !Array.isArray(valor)
)

const selecionarCampos = (item: Record<string, unknown>): OpcaoLocalDeTrabalho => {
  const selecionado = Object.fromEntries(CAMPOS_RESPOSTA
    .filter(campo => Object.prototype.hasOwnProperty.call(item, campo))
    .map(campo => [campo, item[campo]]))
  if (ehRegistro(item.region)) {
    const regiao = item.region
    selecionado.region = Object.fromEntries(['name', 'parent']
      .filter(campo => Object.prototype.hasOwnProperty.call(regiao, campo))
      .map(campo => [campo, regiao[campo]]))
  }
  return selecionado as OpcaoLocalDeTrabalho
}

const criarFalhaRespostaInvalida = (
  resposta: RespostaHttp<unknown>,
): FalhaHttp => new FalhaHttp({
  tipo: 'resposta_invalida',
  servico: 'condominio',
  metodo: 'GET',
  endpoint: ENDPOINT,
  status: resposta.status,
  causa: resposta.data,
  ...(resposta.requestId ? { requestId: resposta.requestId } : {}),
})

export class ListarOpcoesLocalRepositorioHttp {
  constructor(private readonly http: ClienteHttp) {}

  executar = async (
    sinal: AbortSignal,
  ): Promise<readonly OpcaoLocalDeTrabalho[]> => {
    const itens: OpcaoLocalDeTrabalho[] = []
    let totalPaginas = 1
    for (let pagina = 0; pagina < totalPaginas; pagina++) {
      const resposta = await this.http.get<unknown>(ENDPOINT, {
        parametros: {
          fields: JSON.stringify(CAMPOS), order_by: 'name',
          page: pagina, per_page: 1000,
        },
        signal: sinal, retry: ESTRATEGIA_RETRY_PADRAO,
      })
      if (ehRegistro(resposta.data) && 'no-data' in resposta.data && pagina === 0) return []
      if (!ehRegistro(resposta.data) || !Array.isArray(resposta.data.success)) {
        throw criarFalhaRespostaInvalida(resposta)
      }
      const paginas = resposta.data.totalPages
      if (paginas !== undefined) {
        if (typeof paginas !== 'number' || !Number.isSafeInteger(paginas) || paginas < 1) {
          throw criarFalhaRespostaInvalida(resposta)
        }
        if (pagina > 0 && paginas !== totalPaginas) throw criarFalhaRespostaInvalida(resposta)
        totalPaginas = paginas
      }
      itens.push(...resposta.data.success.filter(ehRegistro).map(selecionarCampos))
    }
    return itens
  }
}
